import React from "react";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "../components/Tooltip";
import SuccessIcon from "../assets/successCircle.svg";
import CancelCircleIcon from "../assets/cancelCircle.svg";
import UnverifiedIcon from "../assets/circle-exclamation.svg";
import AccountCircleIcon from "../assets/account_circle.svg";
import TimeIcon from "../assets/pace.svg";
import CalenderIcon from "../assets/calendar_today.svg";
import InfoIcon from "../assets/details.svg";
import { formatDate } from "../utils/utils";

interface VerificationTooltipProps {
  status: "success" | "failure" | "unverified";
  verificationData?: {
    name: string;
    rejected_remarks: string;
    modified_date: string;
  };
}

const VerificationTooltip: React.FC<VerificationTooltipProps> = ({ status, verificationData }) => {
  const getIcon = () => {
    switch (status) {
      case "success":
        return SuccessIcon;
      case "failure":
        return CancelCircleIcon;
      case "unverified":
        return UnverifiedIcon;
    }
  };

  const getTooltipContent = () => {
    switch (status) {
      case "success":
        return (
          <>
            <InfoRow icon={AccountCircleIcon} label="As per API" value={verificationData?.name} />
            <InfoRow icon={TimeIcon} label="Time" value={formatDate(verificationData?.modified_date ?? "", "time")} />
            <InfoRow icon={CalenderIcon} label="Date" value={formatDate(verificationData?.modified_date ?? "", "date")} />
          </>
        );
      case "failure":
        return (
          <>
            <InfoRow icon={InfoIcon} label="Rejected Remarks" value={verificationData?.rejected_remarks} />
            <InfoRow icon={TimeIcon} label="Time" value={formatDate(verificationData?.modified_date ?? "", "time")} />
            <InfoRow icon={CalenderIcon} label="Date" value={formatDate(verificationData?.modified_date ?? "", "date")} />
          </>
        );
      case "unverified":
        return <p className="font-medium text-sm text-[#E3E3E3]">Unverified</p>;
      default:
        return null;
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <img src={getIcon()} alt={status} className="w-5 h-5 cursor-pointer" />
        </TooltipTrigger>
        <TooltipContent
          sideOffset={12}
          align="center"
          className="flex flex-col gap-4 bg-[#1A1A1A] p-4 shadow-md w-auto h-auto rounded-xl border border-[#D0D0D0] overflow-visible relative"
        >
          <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-5 h-5 bg-[#1A1A1A] rotate-45  border border-[#1A1A1A] rounded-md"></div>
          {getTooltipContent()}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

const InfoRow: React.FC<{ icon: string; label: string; value?: string }> = ({ icon, label, value }) => (
  <div className="flex items-center gap-3">
    <div className="w-5 h-5 flex-shrink-0">
      <img src={icon} alt={label} className="w-full h-full" />
    </div>
    <div className="flex flex-col">
      <span className="font-normal text-xs text-[#B5B5B5]">{label}</span>
      <span className="font-medium text-sm text-[#E3E3E3]">{value}</span>
    </div>
  </div>
);

export default VerificationTooltip;
